import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, formatApiErrorDetail } from "@/lib/api";

const ClientAuthContext = createContext(null);
const STORAGE_KEY = "eq_client_token";

const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (t) cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${t}` };
  return cfg;
});

export { clientApi };

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null); // null=loading, false=anon, obj=client
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem(STORAGE_KEY);
      if (!token) {
        setClient(false);
        setReady(true);
        return;
      }
      try {
        const { data } = await clientApi.get("/client-auth/me");
        setClient(data);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
        setClient(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await clientApi.post("/client-auth/login", { email, password });
      if (data?.token) localStorage.setItem(STORAGE_KEY, data.token);
      setClient(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e?.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setClient(false);
  };

  return (
    <ClientAuthContext.Provider value={{ client, ready, login, logout }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
